import {AppUrls} from 'shared/config/model/urls';

import React from 'react';
import {Link} from 'react-router-dom';
import {t} from '@lingui/core/macro';
import cn from 'classnames';

import Problem from 'shared/ui/icons/General/Problem';
import {isTranslate} from 'shared/lib/lang';
import {ServersAlertRulesHintVariant} from 'features/server/lib/serverAlertRuleHelper';

import styles from './ServersAlertRulesHint.module.scss';


interface IServersAlertRulesHintProps {
    variant: ServersAlertRulesHintVariant;
    rulesLimit?: number;
    metricsCount?: number;
    onCreateRule?: () => void;
}

const ServersAlertRulesHint: React.FC<IServersAlertRulesHintProps> = ({
    variant,
    rulesLimit = 0,
    metricsCount = 0,
    onCreateRule,
}) => {
    const linkClassName = cn(styles.link, styles.colorLink);
    const isLimitedMetrics = variant === 'limitedMetrics';

    return (
        <div className={cn(styles.container, isLimitedMetrics ? styles.noticeContainer : styles.alarmContainer)}>
            <span className={styles.icon}>
                <Problem color="currentColor"/>
            </span>
            <span className={styles.text}>
                {isLimitedMetrics
                    ? (
                        <>
                            {t`Вы отслеживаете только ${rulesLimit} из ${metricsCount} метрик.`}
                            {' '}
                            <Link
                                to={isTranslate() ? AppUrls.PRICING : AppUrls.TARIFFS}
                                className={linkClassName}
                            >
                                {t`Увеличьте тариф`}
                            </Link>
                            {t`, чтобы отслеживать все`}
                        </>
                    )
                    : (
                        <>
                            <span className={styles.alarmText}>
                                {t`Метрики серверов не отслеживаются: нет ни одного правила уведомлений.`}
                            </span>
                            {' '}
                            <button
                                type="button"
                                onClick={onCreateRule}
                                className={cn(linkClassName, styles.linkAction)}
                            >
                                {t`Создайте правило`}
                            </button>
                            {t`, чтобы узнавать о проблемах вовремя`}
                        </>
                    )}
            </span>
        </div>
    );
};

export default ServersAlertRulesHint;
